(function ($) {
  'use strict';

  /**
  * Main functionality should be in an 'init' function
  */
  var infoControlsInit = function () {
    var $self = $(this);
    var $btn = $('.info-button', $self);

    if ($self.hasClass('disabled')) {
      $self.find('button').attr('disabled', 'true');
    }

    $btn.click(function () {
      $self.toggleClass('open');
    });
  };

  /**
  * This is boilerplate: add a behavior to window.DP.behaviors
  */
  window.DP.behaviors.infoControls = {
    attach: function (context) {
      $(context).find('.cc--info-controls').once('infoControls').each(function () {
        infoControlsInit.apply(this);
      });
    }
  };
})(jQuery);
